import axios from 'axios';
import React, { createContext, useContext, useState } from 'react';
import { getConfig } from '../misc/helpers';

// ------------------------------------------------------- //

const UserContext = createContext();
const defaultUser = {

    id: null,
    username: null,
    lastID: 1,
    tables: []
}

// ======================================================= //

export const UserProvider = ({children}) => {

    const [user, setUser] = useState(defaultUser);

    const updateUser = async (value) => {
        setUser(value);
        
        await axios.post(
            `${getConfig().url}/api/update/${value.id}`,
            value
        );
    }

    // ------------------------------------------------------- //

    return <UserContext.Provider value={{user, updateUser}}>{children}</UserContext.Provider>
}

export const useUser = () => useContext(UserContext);

// ======================================================= //